import React, { useState, useEffect } from "react";
import { Button, message, Popover, Row, Col, Slider, Spin } from "antd";
import _ from "lodash";
import { IoInformationCircle, IoClose } from "react-icons/io5";
import ReactGA from "react-ga4";
import { useNavigate } from "react-router-dom";

import referalImage from "../../assets/images/icons/cash-collect.png";
import { submitRecommendationApi } from "../../services/recommendation.service";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getProfileApi } from '../../services/profile.service';

interface GoodStuffComponentInterface {
  loadingHistory: boolean;
  historyData?: any;
  tableColumn?: any;
}

const GoodStuffComponent: React.FC<GoodStuffComponentInterface> = (
  props
) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state);
  const { name, userData }: { name?: string; userData?: any } = state?.profile;
  // const url = `${process.env.REACT_APP_SPECIAL_URL}?r=${userData?.referral_code ?? ""
  //   }`;
  const url = `${process.env.REACT_APP_SPECIAL_URL}?r=${userData?.referral_code ?? ""
    }`;
  const [open, setOpen] = useState(false);
  const [sliderValue, setSliderValue] = useState(userData?.recommendation_value ? userData?.recommendation_value : 0);
  const navigate = useNavigate();
  const [loadingProfile, setLoadingProfile] = useState(false)

  useEffect(() => {
    fetchProfile()
  }, [])

  useEffect(() => {
    setSliderValue(userData?.recommendation_value ? userData?.recommendation_value : 0)
  }, [userData])


  const fetchProfile = () => {
    setLoadingProfile(true)
    dispatch(getProfileApi({
      finalCallback: () => {
        setLoadingProfile(false)
      },
      successCallback: (data?: any) => {

      },
      unauthenticatedCallback: () => {

      }
    }))
  }

  const handleUrlClick = () => {
    navigator.clipboard.writeText(url);
    message.success("Url Copied to clipboard");
  };

  const handleSliderSubmit = (val?: any) => {
    dispatch(
      submitRecommendationApi({
        data: { value: val },
        successCallback: (data: any) => {
          setSliderValue(data?.recommendation_value);
        }
      })
    );
  };

  return (
    <>
      <div className="cash-collect">
        <div className="recommendation">
          <h1>
            How likely are you to recommend Missing Skincare to your friends?
          </h1>
          <div className="slider">
            {loadingProfile ?
              <Row justify={"center"} ><Spin /></Row> :
              <Slider
                {...props}
                max={10}
                onChange={(val) => {
                  ReactGA.event({
                    category: "Store",
                    action: `Recommendation slider`,
                    label: "Changed recommendation slider",
                    nonInteraction: true, // optional, true/false
                    transport: "xhr",
                  });
                  setSliderValue(val);
                }}
                onAfterChange={(val) => {
                  handleSliderSubmit(val);
                }}
                value={sliderValue}
                tooltip={{ open: true }}
              />
            }
            <div className="slider__info">
              <span>Not at all likely</span>
              <span>Extremely likely</span>
            </div>
          </div>
        </div>
        {sliderValue >= 5 ? (
          <div className="section">
            <div className="header">
              <h1>Share The Good Stuff</h1>
            </div>
            <Row className="personal-link">
              <Col span={15} xs={24} sm={24} md={24} lg={16}>
                <div
                  className="personal-link__url"
                  onClick={() => {
                    ReactGA.event({
                      category: "Store",
                      action: `Shareable Link Copied`,
                      label: "Shareable Link Copied via Link/Url click",
                      nonInteraction: true, // optional, true/false
                      transport: "xhr",
                    });
                    handleUrlClick();
                  }}
                >
                  {url}
                </div>
              </Col>
              <Col span={6} xs={24} sm={24} md={6} lg={6}>
                <Button
                  className="btn btn-primary"
                  onClick={() => {
                    ReactGA.event({
                      category: "Store",
                      action: `Shareable Link Copied`,
                      label: "Shareable Link Copied via button click",
                      nonInteraction: true, // optional, true/false
                      transport: "xhr",
                    });
                    handleUrlClick();
                  }}
                >
                  Copy Your Special Link
                </Button>
              </Col>
            </Row>
            <div className="infographics">
              <img src={referalImage} alt="Referral-image" />
              <div className="infographics__title-section">
                <h1>For sure, they'll find this refreshing too.</h1>
                <Popover
                  open={open}
                  onOpenChange={(val?: any) => {
                    setOpen(val);
                    if (val) {
                      ReactGA.event({
                        category: "Store",
                        action: `Cash Collect info Icon clicked`,
                        label: "",
                        nonInteraction: true, // optional, true/false
                        transport: "xhr",
                      });
                    }
                  }}
                  overlayClassName="popover"
                  className="popover"
                  placement="bottomRight"
                  content={
                    <>
                      <div
                        className="popover__close"
                        onClick={() => setOpen(false)}
                      >
                        <IoClose />
                      </div>
                      <div className="popover__content">
                        Thank you for sharing Missing Skincare with your friends
                        and family. We do not run any social media ads to
                        maintain the quality of our service. We are grateful to
                        have you and we fully trust you for referring us.
                      </div>
                    </>
                  }
                  trigger="click"
                >
                  <div className="popover__clickable skincare-clickable">
                    <IoInformationCircle className="icon" color="#6489b1" />
                  </div>
                </Popover>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/appreciate-you");
          }}
        >
          Go to Appreciate You
        </Button>
      </div>
    </>
  );
};

export default GoodStuffComponent;
